import { Component, Inject, OnInit, Renderer2, signal, ViewChild, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';

@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class AddMasterProductComponent implements OnInit {
  @ViewChild('dropdownMenu', { static: true }) dropdownMenu: ElementRef;

  public propData: any;
  public bodyParts: any;
  public selectedBodyPart: any = { id: "", value: "" };
  public isEdited: boolean = false;
  public nameTxt: string;
  public search: any;

  isBodyPartDropDown = signal(false);

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if (data) {
      this.propData = data;
      this.bodyParts = this.propData.bodyparts;
    }
  }

  ngOnInit(): void {
    if (this.propData && this.propData.type === "edit") {
      console.log(this.propData, " propData");

      if (this.propData.bodyparts) {
        console.log(this.propData.bodyparts, "bodyparts");

        let bodyparts = this.propData.bodyparts;
        let bodyPartIdToFind = this.propData.item.body_part_id;
        let foundBodyPart = null;
        for (let i = 0; i < bodyparts.length; i++) {
          if (bodyparts[i].id === bodyPartIdToFind) {
            foundBodyPart = bodyparts[i];
            break;
          }
        }

        if (foundBodyPart) {
          this.selectedBodyPart = foundBodyPart;
          console.log(this.selectedBodyPart, "selected body ");
          this.onBodyTypeChange(this.selectedBodyPart);
        } else {
          console.log("No matching body part found for id:", bodyPartIdToFind);
        }
      } else {
        console.log("No bodyparts data available");
      }

      this.nameTxt = this.propData.item.name;
      this.isEdited = true; 
    }

    this.renderer.listen('window', 'click', (e: Event) => {
      if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
        this.isBodyPartDropDown.set(false);
      }
    });
  }

  onClose(): void { 
    this.dialogRef.close();
  }

 

  onBodyTypeChange(value: any) {
    this.selectedBodyPart = value;
    this.isBodyPartDropDown.set(false);
  }

  onAdd() {
    let data = {
      body_part_id: this.selectedBodyPart.id,
      name: this.nameTxt
    }
    if (this.isEdited) {
      this.masterdataService.masterEditBody('implants', this.propData.item.id, data).subscribe((res: any) => {
        this.onClose();
      });
    } else {
      this.masterdataService.masterAddItem('implants', data).subscribe((res: any) => {
        this.onClose();
      });
    }
  }
}
